var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDependants = function SvgDependants(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1029 111 21.55 17.58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dependnt_icon",
    "data-name": "dependnt icon",
    transform: "translate(1029.01 110.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    className: "dependants-1",
    d: "M6.23,17.59A8.32,8.32,0,0,1,.25,15L0,14.79l.16-.32a7,7,0,0,1,6.15-3.85,7,7,0,0,1,6.11,3.75l.17.31-.24.26a8.36,8.36,0,0,1-6.08,2.64Zm-5-3a7.32,7.32,0,0,0,5,2h0a7.36,7.36,0,0,0,5.09-2.06,6,6,0,0,0-5.05-2.9,6,6,0,0,0-5.04,2.98Z",
    transform: "translate(-0.01)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "group-89-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-66-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-64-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    className: "dependants-1",
    d: "M16.75,11.78h0a6.33,6.33,0,0,1-4.5-1.9L12,9.62l.16-.32a5.15,5.15,0,0,1,9.22-.07l.17.32-.24.26a6.24,6.24,0,0,1-4.55,2ZM13.23,9.44a5.33,5.33,0,0,0,3.51,1.34h0A5.16,5.16,0,0,0,18,10.64a5.25,5.25,0,0,0,2.33-1.25,4.14,4.14,0,0,0-7.08.05Zm3.51-4.25h0a2.59,2.59,0,1,1,0-5.18h0a2.6,2.6,0,1,1,0,5.19Zm0-4.19a1.585,1.585,0,1,0,.01,0Z",
    transform: "translate(-0.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group-66-2-2",
    "data-name": "group-66-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-64-2-2",
    "data-name": "path-64-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8430",
    "data-name": "Path 8430",
    className: "dependants-1",
    d: "M6.29,9.26h0a3.375,3.375,0,0,1,0-6.75h0a3.375,3.375,0,0,1,0,6.75Zm0-5.74a2.375,2.375,0,1,0,.01,0Z",
    transform: "translate(-0.01)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDependants, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dependants.b6ee89ae.svg";
export { ForwardRef as ReactComponent };